import { AppState } from "../../store";

//Selectors that pull values from state.
export const selectNavMode = (state: AppState) => state.reducer.Layout.navMode;
export const selectIsLoading = (state: AppState) => state.reducer.Layout.loading;